<template>
  <div class="visitApply">
    <van-nav-bar fixed>
      <div slot="left" @click="close" class="icon-title-line">
        <van-icon name="arrow-left" color="#333" class="icon-title-size" />
      </div>
      <div slot="title" class="all-title">预约申请</div>
    </van-nav-bar>
    <div class="visit-apply-from">
      <van-cell-group>
        <van-field required  v-model="vName" :disabled="isSecond" label="参访人姓名" placeholder="请输入您的姓名" />
        <van-field required v-if="!isSecond" name="radio" label="性别">
          <template #input>
            <van-radio-group v-model="vRadio" direction="horizontal">
              <van-radio name="1">男</van-radio>
              <van-radio name="0">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field required v-else :disabled="isSecond" v-model="vRadioText" label="性别" placeholder="性别" />
        <van-field
          required
          :disabled="isdisabled"
          v-model="vPhone"
          label="手机号码"
          placeholder="请输入您的手机号码"
        />
        <van-field required :disabled="isdisabled" v-model="vIdentity" label="身份证" placeholder="请输入您的身份证号" />
        <van-field  v-model="vCompany" label="所在单位" placeholder="（选填）" />
        <van-field required v-model="vIntervieweeName" label="受访人姓名" placeholder="请输入受访人姓名" />
        <van-field
          required
          v-model="vIntervieweePhone"
          @input="onInputInterviewPhone()"
          label="受访人手机号"
          placeholder="请输入受访人手机号"
        />
        <van-field required v-model="vIntervieweeTime" @click="isShowPreDate=true" label="预约拜访时间" is-link disabled />
        <van-cell required class="visit-explain-title" title="拜访事宜" />
        <van-field
          class="visit-explain"
          v-model="vMessage"
          rows="2"
          autosize
          type="textarea"
          maxlength="100"
          placeholder="请输入拜访原因"
          show-word-limit
          @input="inputEmoji()" 
        />
        <SingleBottomBtn @clickBtn="onSubmit" style="z-index:9" :disabled="disabledBtn">提交</SingleBottomBtn>
      </van-cell-group>
      <!-- 日期 -->
      <van-popup v-model="isShowPreDate" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          :min-date="minDate"
          @confirm="preDateConfirm"
          @cancel="preDateCancle"
          type="datetime"
        ></van-datetime-picker>
      </van-popup>
    </div>
  </div>
</template>
<script>
import SingleBottomBtn from "../../../attendance/components/SingleBottomBtn";
export default {
  name: "visitApply",
  data() {
    return {
      VisitorID: 0, //参访人ID
      InterviewID: null, //受访人ID
      vName: "",
      vRadio: "1",
      vPhone: "",
      vIdentity: "",
      vCompany: "",
      vIntervieweeName: "",
      vIntervieweePhone: "",
      vIntervieweeTime: "",
      vMessage: "",
      vRadioText: "",
      visitorInfos: null, //拜访者所有信息
      interviewInfos: null, //受访者所有信息
      // isShowAgain:false,//是否是第一次申请  为true不是第一次
      isShowPreDate: false,
      minDate: new Date(),
      maxDate: new Date(2025, 10, 1),
      message: "",   
      visitorInfo: {},
      isSecond:false,
      isdisabled:true,
      accountId:0,
      disabledBtn:false
    };
  },
  components: {
    SingleBottomBtn
  },
  created() {
    this.visitorInfo = this.$route.query;
    console.log(this.visitorInfo);
    console.log(Number(this.visitorInfo.VisitorID));
    if (this.visitorInfo.isSecond) {
      this.isSecond = true;
      this.vRadio = this.visitorInfo.Sex
      this.vRadioText = this.vRadio === 1 ? "男" : "女";
    }
    console.log("isSecond", this.isSecond);
    this.vPhone = this.visitorInfo.VisitorPhoneNumber; //手机号
    this.vIdentity = this.visitorInfo.VisitorIdCard ?  this.visitorInfo.VisitorIdCard : '' ; //身份证
    this.vName = this.visitorInfo.VisitorName; //姓名
    this.VisitorID =  Number(this.visitorInfo.VisitorID);//参访人id
    this.vCompany = this.visitorInfo.Address;//单位名称
    this.accountId = localStorage.getItem('accountId')
  },
  mounted() {
    if (this.$route.query.isFromVisitList) {
      this.getVisitorInfo();
    }
  },
  methods: {
    close() {
      this.$router.go(-1);
    },
    //访客日期
    preDateConfirm(val) {
      this.vIntervieweeTime = this.xy.moment(val).format("YYYY-MM-DD HH:mm");
      this.isShowPreDate = false;
    },
    preDateCancle() {
      this.isShowPreDate = false;
    },
    //账号登陆后申请 -- 拜访者手机查询
    async getVisitorInfo() {
      //通过上页登陆传过来的手机号查询访客信息
      let res = await this.xyapi.get(
       this.xyMApi+'/vst' + "/visitor/GetVisitorInfo",
        { PhoneNumber: this.vPhone, IdCard:this.vIdentity , AccountId: Number(this.accountId)}
      );
      if (res !== undefined && res.success) {
        this.VisitorID = res.data ? res.data.UserId : 0;
        this.vName = res.data ? res.data.FullName : ''
        this.vRadio = res.data ? res.data.Sex : '1'
        this.vCompany =  res.data ? res.data.Address : ''//单位名称
        if(res.data && res.data.Sex){
           this.vRadioText = this.vRadio === 1 ? "男" : "女";
        }
      }
    },
    //输入受访者手机号
    onInputInterviewPhone: function() {
      console.log(this.vIntervieweePhone);
      if (
        this.vIntervieweePhone === "" ||
        !/^1[3456789]\d{9}$/.test(this.vIntervieweePhone)
      ) {
        return false;
      } else {
        this.getIntervieweeInfo();
      }
    },
    //------------------受访人手机查询----------------
    async getIntervieweeInfo() {
      //通过上页登陆传过来的手机号查询受访人信息
      let res = await this.xyapi.get(
       this.xyMApi+'/vst' + "/visitor/GetInterviewInfo",
        { PhoneNumber: this.vIntervieweePhone,AccountId: Number(this.accountId)}
      );
      console.log(res);
      //存在返回值 直接跳转到列表页面
      if (res !== undefined && res.success) {
        if (res.data === null) {
          this.xy.msgError("受访人手机号不存在");
          return false;
        } else {
          this.InterviewID = res.data.UserId;
        }
      } else {
        this.xy.msgError("受访人手机号不存在");
        return false;
      }
    },
   inputEmoji(){
      var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\uA9|\uAE]\u3030|\uA9|\uAE|\u3030/ig; 
      if(regStr.test(this.vMessage)){        
          this.vMessage = this.vMessage.replace(regStr,"");   
          }
    },
    async onSubmit() {
      if (this.vName === "") {
        this.xy.msgError("参访人姓名不能为空");
        return false;
      }
      if (this.vPhone === "" || !/^1[3456789]\d{9}$/.test(this.vPhone)) {
        this.xy.msgError("请输入正确手机号");
        return false;
      }
      if (
        this.vIdentity === "" ||
        !/^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/.test(
          this.vIdentity
        )
      ) {
        this.xy.msgError("请输入正确身份证号");
        return false;
      }
      if (this.vIntervieweeName === "") {
        this.xy.msgError("受访人姓名不能为空");
        return false;
      }
      if (
        this.vIntervieweePhone === "" ||
        !/^1[3456789]\d{9}$/.test(this.vIntervieweePhone)
      ) {
        this.xy.msgError("受访人手机号不正确");
        return false;
      }
      if (this.vIntervieweeTime === "") {
        this.xy.msgError("预约拜访时间不能为空");
        return false;
      }
      if (this.vMessage === "") {
        this.xy.msgError("拜访事宜不能为空");
        return false;
      }
      //预约申请
      let params = {
        VisitorID: this.VisitorID, //参访人ID
        VisitorName: this.vName, //参访人姓名
        Sex: Number(this.vRadio), //参访人性别
        VisitorPhoneNumber: this.vPhone, //参访人手机号
        VisitorIdCard: this.vIdentity, //参访人身份证号
        VisitorCompanyAddress: this.vCompany, //参访人所在单位
        InterviewName: this.vIntervieweeName, //受访人姓名
        InterviewPhoneNumber: this.vIntervieweePhone, //受访人手机号
        InterviewID: this.InterviewID, //受访人ID
        ApplicationVisitTimeStr: this.vIntervieweeTime, //申请拜访时间
        VisitReason: this.vMessage, //拜访原因
        AccountId: Number(this.accountId)
      };
      let res = await this.xyapi.post(
           this.xyMApi+'/vst' + "/visitor/AppointmentApply",params
      );
      if (res !== undefined && res.success) {
        if(res.data !== null){
            this.disabledBtn = true
            if (this.xy.getCookie(".XYTOKEN")) {
            //从登陆进来的
            this.$router.push({
                path: "/home/visitSubmission",
                query: {
                isFrom: "VisitApply",
                VisitorRecordID:res.data.VisitorRecordID
                }
            });
            } else {
            //从访客预约进来的
            this.$store.commit("schoolAffairs/setVisitorInfo", res.data);
            this.$router.push({
                path: "/home/visitSubmission",
                query: {
                isFrom: "VisitApplyGo",
                VisitorPhoneNumber:this.vPhone,
                VisitorIdCard:this.vIdentity,
                IsManyTimes:res.data.IsManyTimes
                }
            });
            }
        }else{
            this.xy.msgError(res.msg)
            return false
        }
      }
    }
  },
  watch:{
      vMessage(){
          this.vMessage = this.vMessage.substr(0,100)
      },
      vRadioText(){
        if(this.vRadioText === '男'){
          this.vRadio = 1
        }else if(this.vRadioText === '女'){
          this.vRadio = 0
        }else{
          this.vRadio = this.vRadio
          console.log(this.vRadio)
        }
      }
  }
};
</script>
<style lang="less" scoped>
.visitApply {
  background-color: #ffffff;
  .visit-apply-from{
    padding-bottom: 200px;
    .visit-explain {
      background-color: #f7f7f7;
      width: 92%;
      margin-left: 4%;
    }
  }
}
.icon-title-line{
  display: flex;
  align-items: center;
}
.icon-title-size{
  font-size: 38px;
}

</style>